import axios from "axios";

// Plac API
const API_URL = 'https://publictwin.info/EngagementAppPrototypes/PlacKrakowskiPHP';

// Panel refs
const editPanel = document.getElementById('answer-edit-panel');
const closeButton = document.getElementById('edit-panel-close-button');

const genderSelect = document.getElementById('gender-edit-form');
const ageSelect = document.getElementById('age-edit-form');
const relationSelect = document.getElementById('relation-edit-form');
const customRelationInput = document.getElementById('custom-relation-input');

const editPanelSource = document.getElementById('edit-panel-source');
const editPanelDate = document.getElementById('edit-panel-date');

const imageContainer = document.getElementById('edit-panel-image-container');
const image = document.getElementById('edit-panel-image');

const verifyButton = document.getElementById('edit-panel-verify-button');
const saveButton = document.getElementById('edit-panel-save-button');

const qnaRow = document.getElementById('qna-row');
const adminActionsContainer = document.getElementById('admin-actions-container');

const answerTextarea = document.getElementById('edit-panel-answer-text');
const answerReadonly = document.getElementById('edit-panel-answer-text-readonly');

const zoneSpan = document.getElementById('edit-panel-zone');
const configSpan = document.getElementById('edit-panel-config');

const categoriesContainer = document.querySelector('#categories-edit-container .answer-categories');

const ALL_CATEGORIES = [
  "other", "safety", "comfort", "housing", "experience",
  "identity", "leisure", "activities", "fun", "accessibility",
  "mobility", "infrastructure", "nature", "aesthetics", "biodiversity",
  "economy", "heritage", "tourism", "climate", "privacy"
];

// --- API call to update one answer
function updateAnswer(answerId, data) {
  axios.post(`${API_URL}/Update_Answer_PlacKrakowski.php?id=${answerId}`, data)
    .then(() => refreshFunction?.())
    .catch(err => console.error('Błąd aktualizacji odpowiedzi:', err));
}

let currentAnswers = [];
let refreshFunction;
let originalData = null;

// Toggle custom relation input (Polish)
relationSelect.addEventListener('change', () => {
  if (relationSelect.value === 'inne, jakie:') {
    customRelationInput.classList.remove('hidden');
  } else {
    customRelationInput.classList.add('hidden');
  }
  checkForChanges();
});
customRelationInput.addEventListener('input', checkForChanges);
genderSelect.addEventListener('change', checkForChanges);
ageSelect.addEventListener('change', checkForChanges);
answerTextarea.addEventListener('input', checkForChanges);

verifyButton.addEventListener('click', () => {
  currentAnswers.forEach((answer) => {
    if (String(answer.answer_verified) === "1") return;
    updateAnswer(answer.id, { answer_verified: 1 });
  });
});

closeButton.addEventListener('click', () => editPanel.classList.add('hidden'));

function removePrefix(str, prefix) { return str.startsWith(prefix) ? str.slice(prefix.length) : str; }

// Build editable category chip
function createCategoryDiv(categoryName, isRemovable = true) {
  const div = document.createElement('div');
  div.classList.add('category');
  div.textContent = categoryName;

  if (!isRemovable) return div;

  const btn = document.createElement('button');
  const ico = document.createElement('img');
  btn.classList.add('UrbanFutureReactionsClose', 'UrbanFutureReactions');
  ico.src = 'https://publictwin.info/digital_maquette/content/Urban_Future/Icons/CloseIcon.svg';
  btn.appendChild(ico);
  btn.addEventListener('click', () => {
    const sel = categoriesContainer.querySelector('.category-select');
    div.remove();
    // re-add option
    const opt = document.createElement('option');
    opt.value = categoryName; opt.textContent = categoryName;
    sel.appendChild(opt);
    if (sel.options.length > 1) sel.classList.remove('hidden');
    checkForChanges();
  });
  div.appendChild(btn);
  return div;
}

function createCategorySelect(existing) {
  const tpl = document.createElement('template');
  let html = `<select class="UrbanFutureSelect category-select">
    <option value="" disabled selected hidden>+ nowa</option>`;
  for (const c of ALL_CATEGORIES) {
    if (existing.includes(c)) continue;
    html += `<option value="${c}">${c}</option>`;
  }
  html += `</select>`;
  tpl.innerHTML = html.trim();
  const sel = tpl.content.firstChild;

  sel.addEventListener('change', (ev) => {
    const selected = ev.target.value;
    const chip = createCategoryDiv(selected);
    categoriesContainer.insertBefore(chip, sel);
    sel.querySelector(`option[value="${selected}"]`)?.remove();
    if (sel.options.length === 1) sel.classList.add('hidden');
    sel.value = '';
    checkForChanges();
  });

  return sel;
}

// Returns current form data for comparison/save
function getFormData() {
  const relation = (relationSelect.value === 'inne, jakie:')
    ? `${relationSelect.value} ${customRelationInput.value}`.trim()
    : relationSelect.value;

  const categories = Array.from(categoriesContainer.querySelectorAll('.category'))
    .map(d => d.textContent.trim()).filter(Boolean).sort().join(', ');

  return {
    text: answerTextarea.value,
    gender: genderSelect.value,
    age_group: ageSelect.value,
    relation,
    categories
  };
}

function checkForChanges() {
  if (!originalData) { saveButton.disabled = true; return; }
  const cur = getFormData();
  saveButton.disabled = (JSON.stringify(originalData) === JSON.stringify(cur));
}

saveButton.addEventListener('click', () => {
  const a = currentAnswers[0];
  const f = getFormData();
  updateAnswer(a.id, {
    edited_text: f.text,
    edited_gender: f.gender,
    edited_age_group: f.age_group,
    edited_relation_to_place: f.relation,
    edited_categories: f.categories
  });
});

// ---- OPEN PANEL -------------------------------------------------------------
export default function openEditPanel(answers = [], refreshFn) {
  currentAnswers = answers;
  const data = currentAnswers[0];

  refreshFunction = refreshFn;
  imageContainer.classList.add('hidden');
  editPanel.classList.remove('hidden');
  qnaRow.classList.remove('verified');
  verifyButton.classList.remove('hidden');
  adminActionsContainer.classList.remove('hidden');

  // Źródło / Data
  editPanelSource.textContent = data.source === 'form' ? 'formularz' : 'aplikacja';
  editPanelDate.textContent = data.created_at;

  // Miniatura formularza (jeśli jest)
  if (data.source === 'form' && data.scan_image) {
    imageContainer.classList.remove('hidden');
    image.src = data.scan_image;
  }

  // Weryfikacja
  if (String(data.answer_verified) === "1") {
    qnaRow.classList.add("verified");
    verifyButton.classList.add("hidden");
  }

  // Edytowalność: tylko formularz
  const isEditable = (data.source === 'form');
  genderSelect.disabled = !isEditable;
  ageSelect.disabled = !isEditable;
  relationSelect.disabled = !isEditable;
  customRelationInput.disabled = !isEditable;
  answerTextarea.classList.toggle('hidden', !isEditable);
  answerReadonly.classList.toggle('hidden', isEditable);
  adminActionsContainer.classList.toggle('hidden', !isEditable);

  // Dane uczestnika
  genderSelect.value = data.edited_gender ?? data.gender ?? '-';
  ageSelect.value = data.edited_age_group ?? data.age_group ?? '-';
  relationSelect.value = data.edited_relation_to_place ?? data.relation_to_place ?? '-';

  if (relationSelect.value === '' || relationSelect.value.startsWith('inne')) {
    const rel = data.edited_relation_to_place ?? data.relation_to_place ?? '';
    relationSelect.value = "inne, jakie:";
    // usuń holenderskie prefiksy jeśli by się pojawiły
    let val = rel;
    val = removePrefix(val, 'anders:');
    val = removePrefix(val, 'anders, namelijk:');
    val = removePrefix(val, 'inne, jakie:');
    customRelationInput.value = val.trim();
    customRelationInput.classList.remove('hidden');
  } else {
    customRelationInput.classList.add('hidden');
    customRelationInput.value = '';
  }

  // Odpowiedź
  const answerText = data.edited_text ?? data.answer_text ?? '';
  if (isEditable) {
    answerTextarea.value = answerText;
    answerReadonly.textContent = '';
  } else {
    answerTextarea.value = '';
    answerReadonly.textContent = answerText;
  }

  // Strefa / Konfiguracja
  zoneSpan.textContent = (data.zone_id != null && data.zone_id !== '') ? String(data.zone_id) : '-';
  configSpan.textContent = (data.configuration_id != null && data.configuration_id !== '') ? String(data.configuration_id) : '-';

  // Kategorie
  categoriesContainer.innerHTML = '';
  const catsCSV = (data.edited_categories ?? data.categories ?? '').trim();
  const cats = catsCSV ? catsCSV.split(',').map(s => s.trim()).filter(Boolean) : [];
  for (const c of cats) categoriesContainer.appendChild(createCategoryDiv(c, isEditable));
  if (isEditable) {
    const sel = createCategorySelect(cats);
    categoriesContainer.appendChild(sel);
  }

  // snapshot do porównania
  originalData = getFormData();
  checkForChanges();
}

// Umożliwienie odświeżenia już otwartego panelu
export function refreshEditPanel(changedAnswers) {
  const cur = currentAnswers[0];
  const updated = changedAnswers.find(a => a.id === cur.id);
  if (updated) openEditPanel([updated], refreshFunction);
}
